<template>
  <Authenticated>
    <TrainingNav />
    <div class="form-templates">
      <div class="templates-header">
        <h2>Form Templates</h2>
        <button @click="goToTemplates" class="btn-create">
          <font-awesome-icon icon="fa-plus" />
          Create Form
        </button>
      </div>

      <div v-if="getForms.length >= 1" class="templates-grid">
        <div v-for="form in getForms" :key="form._id" class="template-card">
          <span class="form-icon"><font-awesome-icon icon="fa-file-lines" /></span>
          <div class="form-info">
            <h3>{{ form.title }}</h3>
            <p>{{ form.description }}</p>
          </div>
          <button @click="editForm(form)" class="btn-edit"><font-awesome-icon icon="fa-pen" /> Edit</button>
        </div>
      </div>

      <div v-else class="empty-state">
        <font-awesome-icon icon="fa-file-lines" size="2x" />
        <p>No training forms found</p>
      </div>
    </div>
  </Authenticated>
</template>

<script>
import Authenticated from "../_layouts/Authenticated.vue";
import TrainingNav from "./TrainingNav.vue";
import { mapGetters } from "vuex";

export default {
  name: "FormTemplates",
  components: {
    Authenticated,
    TrainingNav,
    // RolesComponent,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters("training", ["getForms", "isEditing"]),
  },
  methods: {
    editForm(form) {
      this.$store.dispatch("training/editForm", { form });
      this.$router.push("/training/form");
    },

    goToTemplates() {
      this.$store.dispatch("training/editing", false);
      this.$router.push("/training/form");
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
.form-templates {
  margin: 1rem;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: var(--box-shadow);
  background-color: var(--primary-colour);

  .templates-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    h2 {
      margin: 0;
      color: var(--text-colour);
    }
  }

  .btn-create {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1.2rem;
    border-radius: 0.3rem;
    background-color: var(--action-colour);
    color: var(--primary-colour);
    border: 1px solid var(--action-colour);
    cursor: pointer;
    font-weight: 600;
    transition: opacity 0.2s ease;
    &:hover {
      opacity: 0.85;
    }
  }

  .templates-grid {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .template-card {
      display: flex;
      align-items: center;
      gap: 1rem;
      padding: 1rem 1.25rem;
      background-color: var(--secondary-colour);
      border: 1px solid var(--border-colour);
      border-left: 3px solid var(--action-colour);
      border-radius: 0.5rem;
      box-shadow: var(--box-shadow);
      transition: transform 0.15s ease, box-shadow 0.15s ease;

      .form-icon {
        width: 2.5rem;
        height: 2.5rem;
        border-radius: 50%;
        background-color: var(--opacity-background);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--action-colour);
        flex-shrink: 0;
        font-size: 1rem;
      }

      .form-info {
        flex: 1;
        min-width: 0;
        h3 {
          margin: 0 0 0.2rem;
          font-size: 1rem;
          font-weight: 600;
          text-transform: capitalize;
          color: var(--text-colour);
        }
        p {
          margin: 0;
          font-size: 0.85rem;
          color: var(--text-colour);
          opacity: 0.6;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .btn-edit {
        display: inline-flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.5rem 1rem;
        border-radius: 0.3rem;
        background-color: var(--action-colour);
        color: var(--primary-colour);
        border: 1px solid var(--action-colour);
        cursor: pointer;
        font-size: 0.9rem;
        font-weight: 500;
        flex-shrink: 0;
        transition: opacity 0.2s ease;
        &:hover {
          opacity: 0.85;
        }
      }
    }
  }

  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    color: var(--text-colour);
    opacity: 0.4;
    gap: 0.75rem;
    p {
      margin: 0;
      font-size: 1rem;
    }
  }
}
</style>
